import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { FormBuilder, FormControl, FormArray, FormGroup, Validators, AbstractControl } from '@angular/forms';

@Component({
  selector: 'career-academy-questiontype',
  templateUrl: './career.academy.component.html'
})
export class CareerAcademyComponent implements OnInit, OnDestroy {
  @Input() required:boolean;
  @Input() prompt:string;
  @Input() tooltip:string;
  @Input() questionid:number;
  @Input() disabled:boolean;
  @Input() jsclassinit:any;

  canAddOther:boolean=false;
  hasOther:boolean=false;
  other:string='';
  validationMessages: any;
  _value:any;
  formErrors:any;
  formSegment:FormGroup;
  _touched:boolean=false;
  value:Array<string>=[];

  public getValue(){
    var result={},value=[];
    if(!this.disabled) {

      if(this.hasOther) {
        value.push(this.other);
      }
      for(let i in this.formSegment.controls) {
        if(this.formSegment.controls[i].value) {
          value.push(i);
        }
      }
      result[this.questionid]=value;
    } else {
      result[this.questionid]=null;
    }
    return result;
  }

  constructor() {
  }

  get touched():boolean {
    if(this._touched) {
      return true;
    }
    for(let i in this.formSegment.controls) {
      if(this.formSegment.controls[i].touched || this.formSegment.controls[i].dirty) {
        this._touched=true;
        return true;
      }
    }
    return false;
  }

  isValid():boolean {
    var value;
    if(!this.disabled && this.required) {
      for(let i in this.formSegment.controls) {
        if(!!this.formSegment.controls[i].value) {
          return true;
        }
      }
      if (this.canAddOther && this.hasOther && !!this.other) {
        return true;
      }
      return false;
    }
    return true;
  }
  validate():boolean {
    this._touched=true;
    return this.isValid();
  }

  ngOnInit() {
    if(!!this.jsclassinit && !!this.jsclassinit.canAddOther) {
      this.canAddOther=true;
    }
    var init={};
    init['Agriculture & Natural Resources']=new FormControl();
    init['Art, Media & Entertainment']=new FormControl();
    init['Building & Construction Technologies']=new FormControl();
    init['Business & Finance']=new FormControl();
    init['Education']=new FormControl();
    init['Energy, Environment and Utilities']=new FormControl();
    init['Engineering & Architecture']=new FormControl();
    init['Fashion & Interior Design']=new FormControl();
    init['Health Sciences & Medical Technology']=new FormControl();
    init['Hospitality, Tourism & Recreation']=new FormControl();
    init['Information & Communication Technologies']=new FormControl();
    init['Manufacturing & Product Development']=new FormControl();
    init['Marketing, Sales & Services']=new FormControl();
    init['Public Services']=new FormControl();
    init['Transportation']=new FormControl();

    this.formSegment=new FormGroup(init);

    if(!!this.value) {
      this.value.forEach((item)=>{
        if(item in this.formSegment.controls) {
          this.formSegment.controls[item].setValue(true);
        } else if (this.canAddOther) {
          this.hasOther=true;
          this.other=item;
        }
      });
    }
  }

  ngOnDestroy() {
  }
}




// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/questionnaire/elements/career.academy.component.ts